// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export class SiteSharedContactUpsearchModel {
    static getAttributeTypeMap() {
        return SiteSharedContactUpsearchModel.attributeTypeMap;
    }
}
SiteSharedContactUpsearchModel.discriminator = undefined;
SiteSharedContactUpsearchModel.additionalProperties = false;
SiteSharedContactUpsearchModel.attributeTypeMap = [
    {
        "name": "addresses",
        "baseName": "addresses",
        "type": "Array<SiteSharedAddressUpsearchModel>"
    },
    {
        "name": "emailAddresses",
        "baseName": "emailAddresses",
        "type": "Array<SiteSharedEmailAddressUpsearchModel>"
    },
    {
        "name": "phoneNumbers",
        "baseName": "phoneNumbers",
        "type": "Array<SiteSharedPhoneUpsearchModel>"
    },
    {
        "name": "webAddresses",
        "baseName": "webAddresses",
        "type": "Array<SiteSharedWebAddressUpsearchModel>"
    },
    {
        "name": "contactId",
        "baseName": "contactId",
        "type": "number"
    },
    {
        "name": "contactType",
        "baseName": "contactType",
        "type": "RoleType"
    },
    {
        "name": "firstName",
        "baseName": "firstName",
        "type": "string"
    },
    {
        "name": "lastName",
        "baseName": "lastName",
        "type": "string"
    },
    {
        "name": "occupationDescription",
        "baseName": "occupationDescription",
        "type": "string"
    },
    {
        "name": "isMainContact",
        "baseName": "isMainContact",
        "type": "boolean"
    },
];
//# sourceMappingURL=siteSharedContactUpsearchModel.js.map